import {useRef, useEffect, useState} from "react";

export default function AnimatedHeight({open, children}: {open: boolean, children: React.ReactNode}) {
    const ref = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<string | number>(0);

    useEffect(() => {
        if (open && ref.current) {
            const scrollHeight = ref.current.scrollHeight;
            setHeight(scrollHeight);
            const timeout = setTimeout(() => setHeight('auto'), 300);
            return () => clearTimeout(timeout);
        } else if (!open) {
            if (ref.current) {
                setHeight(ref.current.scrollHeight);
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => setHeight(0));
                });
            } else {
                setHeight(0);
            }
        }
    }, [open]);

    return (
        <div
            ref={ref}
            style={{
                overflow: 'hidden',
                transition: 'height 0.3s ease-in-out',
                height: height
            }}
        >
            {children}
        </div>
    );
}